import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BreadcrumbItemProps } from '@gerdau/hefesto-mais-web/Breadcrumbs/Breadcrumbs.types';

import NavegationMenuBar from '../../../../components/NavegationMenuBar';
import usePurchaseSubheader from './usePurchaseSubheader';
import { ELocalStorageKey } from '../../../../services/EGerdauService/types';
import { EPurchaseRoutes } from '../../purchase.routes';
import { EOrderSettingsRoutes } from '../OrderSettingsMvp/orderSettings.routes';
import StepByStepComponent from './StepByStepComponent';

import { CustomTitleWrapper, SectionHeader, TitleBox } from './styles';

const CheckoutSteps = ({ canRender }: { canRender: boolean }) => {
  if (!canRender) {
    return null;
  }

  return <StepByStepComponent />;
};
const PurchaseSubHeaderMvp: React.FC = () => {
  const { pathname } = useLocation();
  const { headerText } = usePurchaseSubheader();
  const [menuLinks, setMenuLinks] = useState<BreadcrumbItemProps[]>([]);

  const itemNavBuy = {
    name: 'Comprar',
    url: `${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`
  };
  const itemNavBuySearchingItems = {
    name: 'Comprar selecionando itens',
    url: `${EOrderSettingsRoutes.SEARCH_ITEMS}`
  };
  const itemNavBuyCatalog = {
    name: 'Comprar por vitrine',
    url: `${EOrderSettingsRoutes.CATALOG}`
  };
  const itemNavBuyCartConfigure = {
    name: 'Configurar carrinho',
    url: `${EOrderSettingsRoutes.SHOPPING_CART}`
  };
  const itemNavBuyBySheet = {
    name: 'Comprar via planilha',
    url: `${EOrderSettingsRoutes.SPREADSHEET_UPLOAD}`
  };
  const itemNavBuyByHistory = {
    name: 'Comprar por histórico',
    url: `${EOrderSettingsRoutes.REPEAT_ORDER}`
  };
  const itemNavProductDetails = {
    name: 'Detalhes do produto',
    url: `${EOrderSettingsRoutes.PRODUCT}`
  };

  const updateMenuLinks = ({
    items,
    include
  }: {
    items: BreadcrumbItemProps[];
    include?: boolean;
  }) => {
    if (include) {
      const menuLinksCache =
        localStorage.getItem(ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION) ?? '';

      if (
        menuLinksCache ||
        typeof menuLinksCache === 'object' ||
        typeof menuLinksCache === 'function'
      ) {
        const convertedLinks = JSON.parse(
          menuLinksCache ?? ''
        ) as unknown as BreadcrumbItemProps[];
        if (convertedLinks) {
          const existCartLink = convertedLinks.find(
            (link: BreadcrumbItemProps) =>
              link.name === itemNavBuyCartConfigure.name
          );
          const newMenuLink = [
            ...convertedLinks,
            ...(existCartLink?.name !== itemNavBuyCartConfigure.name
              ? items
              : [])
          ];
          setMenuLinks(newMenuLink);
          localStorage.setItem(
            ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION,
            JSON.stringify(newMenuLink)
          );
        }
        return;
      }
    }
    setMenuLinks(items);
    localStorage.setItem(
      ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION,
      JSON.stringify(items)
    );
  };

  useEffect(() => {
    if (pathname.includes(EOrderSettingsRoutes.SEARCH_ITEMS)) {
      updateMenuLinks({ items: [itemNavBuy, itemNavBuySearchingItems] });
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.PRODUCT)) {
      updateMenuLinks({
        items: [itemNavBuy, itemNavBuyCatalog, itemNavProductDetails]
      });
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.CATALOG)) {
      updateMenuLinks({ items: [itemNavBuy, itemNavBuyCatalog] });
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.REPEAT_ORDER)) {
      updateMenuLinks({ items: [itemNavBuy, itemNavBuyByHistory] });
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.SPREADSHEET_UPLOAD)) {
      updateMenuLinks({ items: [itemNavBuy, itemNavBuyBySheet] });
      return;
    }

    if (pathname.includes(EOrderSettingsRoutes.SHOPPING_CART)) {
      updateMenuLinks({ items: [itemNavBuyCartConfigure], include: true });
      return;
    }

    // Caso o usuário atualize a página
    const menuLinksCache = localStorage.getItem(
      ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION
    );
    if (
      menuLinksCache &&
      (typeof menuLinksCache === 'object' ||
        typeof menuLinksCache === 'function')
    ) {
      updateMenuLinks(JSON.parse(menuLinksCache));
    }
  }, [pathname]);

  return (
    <SectionHeader>
      <TitleBox>
        <NavegationMenuBar
          notRender={
            pathname.includes(EOrderSettingsRoutes.SHOPPING_CART) ||
            pathname.includes(EOrderSettingsRoutes.CHECKOUT) ||
            pathname.includes(EOrderSettingsRoutes.FINALIZE_ORDER)
          }
          items={menuLinks && menuLinks.length > 0 ? menuLinks : []}
        />
        <CustomTitleWrapper>
          <h1>{headerText.title}</h1>
          <span>{headerText.supportText}</span>
        </CustomTitleWrapper>
      </TitleBox>
      <CheckoutSteps
        canRender={pathname.includes(EOrderSettingsRoutes.CHECKOUT)}
      />
    </SectionHeader>
  );
};

export default PurchaseSubHeaderMvp;
